import type { RootState } from "types/redux";

export const getPinnedKnowledgeHasNextPage = (state: RootState) =>
  state.domains.pinAddReject.pinnedKnowledge.hasNextPage;

export const getPinnedKnowledgeCurrentTopicId = (state: RootState) =>
  state.domains.pinAddReject.pinnedKnowledge.currentTopicId;

export const getPinnedKnowledge = (state: RootState) => state.domains.pinAddReject.pinnedKnowledge.data;

export const getPinnedKnowledgeTotalCount = (state: RootState) => state.domains.pinAddReject.pinnedKnowledge.totalCount;

export const getIsPinnedKnowledgePending = (state: RootState) =>
  state.domains.pinAddReject.pinnedKnowledge?.isPending ?? false;

export const getIsPinPending = (knowledgeId: string) => (state: RootState) =>
  state.domains.pinAddReject.pinnedKnowledgeUpdateStatus?.[knowledgeId]?.isPending ?? false;

export const getPinnedKnowledgePaginationState = (state: RootState) => state.domains.pinAddReject.pinnedKnowledge;

export const getIsApproveKnowledgePending = (state: RootState) =>
  state.domains.pinAddReject.approveKnowledgeStatus.isApproveKnowledgePending;

export const checkIsKnowledgePinnedForTopic = (knowledgeId: string, topicId: string) => (state: RootState) =>
  state.domains.pinAddReject.perKnowledge?.[knowledgeId]?.topicIds.includes(topicId) ?? false;

export const checkIsKnowledgeStored = (knowledgeId: string) => (state: RootState) =>
  !!state.domains.pinAddReject.perKnowledge?.[knowledgeId];

export const checkArePinningTopicsPending = (knowledgeId: string) => (state: RootState) =>
  state.domains.pinAddReject.perKnowledge?.[knowledgeId]?.areTopicsPending ?? false;
